import { t } from "../i18n";

/**
 * Toast — การ์ดแจ้งเตือนพื้นเข้ม + ไอคอนวงกลมสี + หัวข้อ + คำอธิบาย
 * ใช้ร่วมกันทุกหน้า (ลูกค้า/แอดมิน) วางมุมขวาบนใต้ navbar
 *
 * props:
 *   show     — แสดงหรือไม่ (falsy = ไม่ render)
 *   type     — "success" | "error" | "warning" | "info"
 *   message  — ข้อความ (เป็นคำอธิบายใต้หัวข้อ)
 *   title    — หัวข้อ (ไม่ใส่ = ใช้ค่าเริ่มต้นตาม type)
 *   lang     — "th" | "en" (สำหรับหัวข้อเริ่มต้น)
 */
const CONFIG = {
  success: { ring: "#16a34a", tint: "rgba(34,197,94,.16)",  titleColor: "#14532d", titleKey: "toastSuccess" },
  error:   { ring: "#e11d48", tint: "rgba(239,68,68,.16)",  titleColor: "#9f1239", titleKey: "toastError"   },
  warning: { ring: "#d97706", tint: "rgba(245,158,11,.18)", titleColor: "#92400e", titleKey: "toastWarn"    },
  info:    { ring: "#2563eb", tint: "rgba(59,130,246,.16)", titleColor: "#1e3a8a", titleKey: "toastInfo"    },
};

function Glyph({ type }) {
  const p = { width: 14, height: 14, viewBox: "0 0 24 24", fill: "none",
    stroke: "#fff", strokeWidth: 2.6, strokeLinecap: "round", strokeLinejoin: "round" };
  if (type === "success") return <svg {...p}><polyline points="20 6 9 17 4 12" /></svg>;
  if (type === "error")   return <svg {...p}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
  if (type === "warning") return <svg {...p}><line x1="12" y1="7" x2="12" y2="13" /><line x1="12" y1="17" x2="12" y2="17" /></svg>;
  return <svg {...p}><line x1="12" y1="11" x2="12" y2="17" /><line x1="12" y1="7" x2="12" y2="7" /></svg>;
}

export default function Toast({ show = true, type = "info", message, title, lang = "th" }) {
  if (!show || !message) return null;
  const c = CONFIG[type] || CONFIG.info;
  const heading = title || t(lang, c.titleKey);

  return (
    <div
      style={{
        position: "fixed", top: 76, right: 28, zIndex: 100000,
        display: "flex", alignItems: "flex-start", gap: 12,
        minWidth: 300, maxWidth: 380, padding: "14px 16px",
        borderRadius: 16, color: "#1f2937",
        background: `linear-gradient(135deg, ${c.tint}, rgba(255,255,255,.80))`,
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        border: "1px solid rgba(255,255,255,.7)",
        boxShadow: "0 10px 30px rgba(0,0,0,.14), inset 0 1px 0 rgba(255,255,255,.85)",
        fontFamily: "'Noto Sans Thai',sans-serif",
        animation: "toastSlideIn .22s ease",
      }}
    >
      <span
        style={{
          flexShrink: 0, width: 26, height: 26, marginTop: 1,
          borderRadius: "50%", background: c.ring,
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: `0 0 0 4px ${c.ring}22`,
        }}
      >
        <Glyph type={type} />
      </span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 700, lineHeight: 1.3, color: c.titleColor }}>{heading}</div>
        <div style={{ fontSize: 12.5, lineHeight: 1.45, marginTop: 2, color: "#4b5563" }}>
          {message}
        </div>
      </div>
    </div>
  );
}
